var React = require('react');

function SectionArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.8343 0L9.34572 2.43793L14.7441 7.76207H0.449219V11.2034H14.7441L9.34572 16.5276L11.8343 18.9655L21.4274 9.48276L11.8343 0Z","fill":"#1A1A1A"}));
}

SectionArrow.defaultProps = {"width":"22","height":"19","viewBox":"0 0 22 19","fill":"none"};

module.exports = SectionArrow;

SectionArrow.default = SectionArrow;
